import Cookies from "js-cookie";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/Methods";
import { APIS } from "../../utils/APIS";
import { IDS } from "../../utils/IDS";

export const sendLoginOtp = createAsyncThunk(
  "/sendLoginOtp",
  async (data, { rejectWithValue }) => {
    try {
      const otp = await POST(APIS.Auth.sendLoginOtp, data);
      if (otp?.success === false) {
        return rejectWithValue(otp);
      }
      return otp;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const LoginverifyOtp = createAsyncThunk(
  "/login",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.LoginverifyOtp, data);
    return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const AuthLogOut = createAsyncThunk(
  "login/logout",
  async (_, { rejectWithValue }) => {
    try {
      // Remove cookies
      Cookies.remove("excellent_website_security");
      // Cookies.remove("ots_user_type");

      // Return reset state
      return {
        loginData: null,
        loginStatus: IDS.SLICESTATUS.Idle,
        loginError: null,
        verifyLoginOtpData: null,
        verifyLoginOtpStatus: IDS.SLICESTATUS.Idle,
        verifyLoginOtpError: null,
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);


export const LoginSlice = createSlice({
  name: "login",
  initialState: {
    isLoggedIn: false,
    
    loginData: null,
    loginStatus: IDS.SLICESTATUS.Idle,
    loginError: null,

    signupData: null,
    signupStatus: IDS.SLICESTATUS.Idle,
    signupError: null,

    sendOtpData: null,
    sendOtpStatus: IDS.SLICESTATUS.Idle,
    sendOtpError: null,

    verifyOtpData: null,
    verifyOtpStatus: IDS.SLICESTATUS.Idle,
    verifyOtpError: null,

    sendLoginOtpData: null,
    sendLoginOtpStatus: IDS.SLICESTATUS.Idle,
    sendLoginOtpError: null,

    verifyLoginOtpData: null,
    verifyLoginOtpStatus: IDS.SLICESTATUS.Idle,
    verifyLoginOtpError: null,

    getCustomerData: null,
    getCustomerStatus: IDS.SLICESTATUS.Idle,
    getCustomerError: null,

    getVendorData: null,
    getVendorStatus: IDS.SLICESTATUS.Idle,
    getVendorError: null,

    getExpertData: null,
    getExpertStatus: IDS.SLICESTATUS.Idle,
    getExpertError: null,

    updateCustomerStatus: IDS.SLICESTATUS.Idle,
    updateCustomerError: null,

    updateExpertStatus: IDS.SLICESTATUS.Idle,
    updateExpertError: null,

    updateVendorStatus: IDS.SLICESTATUS.Idle,
    updateVendorError: null,

    getVendorShopData: null,
    updateVendorShopStatus: IDS.SLICESTATUS.Idle,
    updateVendorShopError: null,
  },
  reducers: {
    logoutUser: (state) => {
      Cookies.remove("excellent_website_security");
     

      state.loginData = null;
      state.signupData = null;
      state.loginStatus = IDS.SLICESTATUS.Idle;
      state.signupStatus = IDS.SLICESTATUS.Idle;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(sendLoginOtp.pending, (state) => {
        state.sendLoginOtpStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(sendLoginOtp.fulfilled, (state, action) => {
        state.sendLoginOtpStatus = IDS.SLICESTATUS.Succeeded;
        state.sendLoginOtpData = action.payload?.data || null;
      })
      .addCase(sendLoginOtp.rejected, (state, action) => {
        state.sendLoginOtpStatus = IDS.SLICESTATUS.Failed;
        state.sendLoginOtpError = action.payload;
      })

      .addCase(LoginverifyOtp.pending, (state) => {
        state.verifyLoginOtpStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(LoginverifyOtp.fulfilled, (state, action) => {
        state.verifyLoginOtpStatus = IDS.SLICESTATUS.Succeeded;
        state.verifyLoginOtpData = action.payload?.data || null;
        state.isLoggedIn = true;
      })
      .addCase(LoginverifyOtp.rejected, (state, action) => {
        state.verifyLoginOtpStatus = IDS.SLICESTATUS.Failed;
        state.verifyLoginOtpError = action.payload;
      })

      .addCase(AuthLogOut.pending, (state) => {
        state.loginStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(AuthLogOut.fulfilled, (state, action) => {
        state.loginStatus = IDS.SLICESTATUS.Idle;
        state.loginData = null;
        state.loginError = null;
        state.verifyLoginOtpData = null;
        state.verifyLoginOtpStatus = IDS.SLICESTATUS.Idle;
        state.verifyLoginOtpError = null;
      })
      .addCase(AuthLogOut.rejected, (state, action) => {
        state.loginStatus = IDS.SLICESTATUS.Failed;
        state.loginError = action.payload || "Logout failed";
      });
    ;
  },
});

export const { logoutUser } = LoginSlice.actions;
export default LoginSlice.reducer;
